import React, { PropTypes, Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from './actions';

import * as globalActions from "../../../action/CommonActions";

import { getCorporateQuotesForApproval } from './selector';

import { FilterGroup, CountryFilter, CostcenterFilter, DateRangeFilter } from '../../../components/filter';

import QuoteDetails from './components/QuoteDetails';

import moment from 'moment';

import QuoteApprovalGrid from './components/QuoteApprovalGrid';

import FilterMobileComponent from '../../../components/common/FilterMobileComponent';

import Breakpoint from '../../../utils/breakpoints';

import { NitroHeading, NitroSearchBar, NitroSingleSelect, NitroDrawer, NitroPanel } from 'nitro-components';

const TABLE_ROW_LIMIT = 15;

import styled from 'styled-components';
import Header from '../../../components/layouts/Header';

const RightActions = styled.div`
  float: right;
  margin-bottom: 20px;
`;

const StatusSelect = styled.div`
  display: inline-block;
  margin-left: 30px;
  min-width: 200px;
`;

class QuoteApproval extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCode: '',
      companyCode: '',
      status: -1,
      open: false,
      quoteId: '',
      dateFilter: {
        value: 1,
        type: 1
      },
      search: '',
      sortQuery: '',
      currentPage: 0,
      emailList: {}
    };
  }

  componentWillMount() {
    const { country, costcenter, dateFilter } = this.props;

    this.getQuotes(country, costcenter, dateFilter, 0);
  }

  getOptions = (countryObject, costcenterObject, dateFilterObject) => {
    let { dateFilter, country, costcenter } = this.props;
    dateFilter = dateFilterObject || dateFilter;
    country = countryObject || country;
    costcenter = costcenterObject || costcenter;

    let options = {
      countryCode: country.value,
      companyCode: costcenter.value
    };

    let startDate, endDate;

    if (dateFilter.type === 'custom') {
      startDate = dateFilter.value.start;
      endDate = dateFilter.value.end;
    } else {
      const now = new Date();
      startDate = moment(now).subtract(dateFilter.value, 'year').format('D MMM YY');
      endDate = moment(now).format('D MMM YY');
    }

    if (startDate && endDate) {
      options = {
        ...options,
        startDate,
        endDate
      };
    }

    return options;
  };

  getQuotes = (country, costcenter, dateFilter, currentPage) => {
    const page = currentPage;
    const options = this.getOptions(country, costcenter, dateFilter);
    this.props.actions.fetchQuotesApproval({
      status: this.state.status === -1 ? null : this.state.status,
      countryCode: options.countryCode,
      companyCode: options.companyCode,
      startDate: options.startDate,
      endDate: options.endDate,
      offset: page * TABLE_ROW_LIMIT,
      limit: TABLE_ROW_LIMIT,
      lookup: this.state.search,
      sort: this.state.sortQuery
    });
  };
  getQuotesApproval = (country, costcenter, dateFilter) => {
    this.props.actions.fetchQuotesApproval(this.getOptions(country, costcenter, dateFilter));
  };

  setSource = filterSource => {
    const country = filterSource[0];
    const costcenter = filterSource[1];
     const { setGlobalCountryCostCenter } = this.props.globalActions;
    setGlobalCountryCostCenter({country: country,costcenter: costcenter});
    this.setState({
      companyCode: filterSource[1].value,
      countryCode: filterSource[0].value,
      currentPage: 0
    });
    this.getQuotes(country, costcenter, null, 0);
  };

  setFilters = filterDate => {
    this.props.actions.setFilter(filterDate[0]);
    this.setState({
      currentPage: 0,
      dateFilter: filterDate[0]
    });
    this.getQuotes(null, null, filterDate[0], 0);
  };

  setStatus = option => {
    this.setState(
      {
        status: option.value
      },
      () => {
        this.getQuotes(this.props.country, this.props.costcenter, this.props.dateFilter, 0);
      }
    );
  };

  fetchGridData = (currentPage, sortQuery) => {
    this.setState(
      {
        sortQuery: sortQuery,
        currentPage: currentPage
      },
      function() {
        this.getQuotes(null, null, null, currentPage);
      }.bind(this)
    );
  };

  search = text => {
    this.setState(
      {
        search: text.toLowerCase(),
        currentPage: 0
      },
      function() {
        this.getQuotes(null, null, null, 0);
      }.bind(this)
    );
  };

  onQuoteApprovalRowClick = rowData => {
    this.openSidePanel(rowData.props.data.QuoteId);
  };

  openSidePanel = quoteId => {
    this.setState({
      quoteId: quoteId,
      open: true
    });
  };

  closeSidePanel = () => {
    this.setState({
      open: false
    });
  };

  sendEmail = params => {
    const id = `${params.QuoteId}-${params.ApproverId}`;
    this.setState({
      emailList: { ...this.state.emailList, [id]: false }
    });

    this.props.actions.sendEmail(params).then(() => {
      this.setState({
        emailList: { ...this.state.emailList, [id]: true }
      });
    });
  };

  render() {
    const { country, costcenter, dateFilter } = this.props;
    const source = [
      {
        title: 'Country',
        component: CountryFilter,
        ...country
      },
      {
        title: 'Cost Centre',
        component: CostcenterFilter,
        ...costcenter
      }
    ];

    const filters = [
      {
        title: 'Time period',
        component: DateRangeFilter,
        options: [
          {
            label: 'Past year',
            value: 1
          },
          {
            label: 'Past 2 years',
            value: 2
          }
        ],
        ...dateFilter
      }
    ];

    const statusList = [
      {
        label: 'All status',
        value: -1
      },
      {
        label: 'Pending',
        value: 1
      },
      {
        label: 'Approved',
        value: 2
      },
      {
        label: 'Declined',
        value: 3
      },
      {
        label: 'Submitted',
        value: 4
      }
    ];

    return (
      <section>
        <Breakpoint name="desktop">
          <Header>
            <NitroHeading label="Quote Approval" header inline noMargin />
            <FilterGroup width="85%" action={this.setSource} title="Source" icon="source" filters={source} align="right" />
          </Header>
        </Breakpoint>

        <NitroPanel padding="16px">

          <Breakpoint name="desktop">
            <FilterGroup action={this.setFilters} title="Filters" icon="filter" filters={filters} />
          </Breakpoint>

          <Breakpoint name="mobileTablet">
            <FilterMobileComponent
              filter
              onClickSource={this.setSource}
              onClickFilter={this.setFilters}
              source={source}
              filters={filters}
            />
          </Breakpoint>

          <RightActions>

            <NitroSearchBar
              hintText={'Search quote reference, creator name'}
              action={text => this.search(text)}
              width={280}
              float="left"
            />
            <StatusSelect>
              <NitroSingleSelect
                value={this.state.status}
                mandatory
                bold
                options={statusList}
                action={this.setStatus}
              />
            </StatusSelect>
          </RightActions>

          <QuoteApprovalGrid
            data={this.props.quotes}
            total={this.props.totalQuotes}
            getExternalData={this.fetchGridData}
            rowCount={TABLE_ROW_LIMIT}
            onRowClick={this.onQuoteApprovalRowClick}
            currentPage={this.state.currentPage}
            dataFetching={this.props.fetchingQuotes}
          />

        </NitroPanel>
        <NitroDrawer isOpen={this.state.open} close={this.closeSidePanel} noPadding width={460} variant="white">
          <QuoteDetails
            open={this.state.open}
            quoteId={this.state.quoteId}
            countryCode={this.state.countryCode}
            companyCode={this.state.companyCode}
            sendEmail={this.sendEmail}
            emailList={this.state.emailList}
            {...this.props}
          />
        </NitroDrawer>
      </section>
    );
  }
}

QuoteApproval.propTypes = {
  quotes: PropTypes.array,
  actions: PropTypes.object.isRequired,
  country: PropTypes.object.isRequired,
  costcenter: PropTypes.object.isRequired,
  dateFilter: PropTypes.object.isRequired,
  totalQuotes: PropTypes.number.isRequired,
  fetchingQuotes: PropTypes.bool.isRequired,
  globalActions: PropTypes.object
};

const mapStateToProps = state => {
  /*const { approval } = state.corporateQuote;
  const { costcenter, country } = setDefaultSource(
    approval.country,
    approval.costcenter,
    getCountries(state.auth.config.filters)
  );

  const {
    dateFilter,
    quotes,
    fetchingQuotes,
    totalQuotes,
    quoteSummary,
    fetchingQuoteSummary
  } = approval;
  const summary = formateSummary(quoteSummary);
  return {
    ...summary,
    statusList: quoteSummary.WorkflowSummary,
    status: quoteSummary.Status,
    fetchingQuoteSummary,

    country,
    costcenter,
    dateFilter,
    quotes,
    fetchingQuotes,
    totalQuotes
  };*/
  //Reselect refactor
  return getCorporateQuotesForApproval(state);
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  globalActions: bindActionCreators(globalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuoteApproval);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/QuoteApproval.js